// Service worker registration.
//
// Adapted from the CRA PWA template, trimmed to what this app uses. Registration
// is opt-in per build: it only runs in production, because a service worker in
// development caches the dev bundle and makes changes appear not to take.
//
// The localhost branch matters — without it, a stale worker registered by an
// earlier build keeps serving its cache on localhost:3000 and every dev after
// that debugs a bundle they aren't editing.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(\.(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  // The worker cannot control pages on a different origin than the bundle.
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            // An older worker is still serving the page, so this is an update
            // rather than a first install. It stays in "waiting" until the user
            // accepts it.
            if (config && config.onUpdate) config.onUpdate(registration);
          } else if (config && config.onSuccess) {
            config.onSuccess(registration);
          }
        };
      };
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // On localhost, confirm a worker actually exists before trusting it. A build
  // that no longer ships one would otherwise leave the old worker in control.
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      const missing =
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1);

      if (missing) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.error(error.message));
}
